<template>
  <p>
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'btn-input'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.btn-input {
  background-color: $dark;
  max-width: 130px;
  width: 100%;
  border-radius: 30px;
  margin-left: 15px;
  display: inline-block;
  @include mq-up(md) {
    max-width: 140px;
  }
  &.btncenter {
    text-align: center;
  }
  > a {
    font-size: 14px;
    color: #fff;
    display: block;
    text-decoration: none;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
    line-height: 100%;
    @include mq-up(md) {
      font-size:16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/BtnInput.vue